module.exports.app_id = "BountyHub";

module.exports.api_url = "https://api.bountyhub.net";
module.exports.api_token = "jEVv3Lp23lnMGiEc";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://192.168.0.10:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js